import React, { useEffect } from 'react';
import { View } from 'react-native';
import { DimensionsContext } from "@common/utils/mobileUtils";
import StudyProgramsFilterList from "@common/chapters/StudyProgramsFilterList";
import StudyProgramDisplayComponent from "../studyPrograms/components/StudyProgramDisplayComponent";
import { connect } from "react-redux";
import { hasRole } from "@data/utility/ability";

const StudyProgramChapterSelector = (props) => {
    const {
        studentIds,
        selectedStudyProgramId,
        setSelectedStudyProgramId,
        onSelectChapter,
        dimensions,
        initialSelectedChapter,
        studyPrograms
    } = props;

    console.log("StudyProgramChapterSelector props:", {
        initialSelectedChapter,
        studyPrograms: studyPrograms?.map(p => ({
            id: p.id,
            chapters: p.chapters?.map(c => ({
                id: c.id,
                name: c.name
            }))
        }))
    });

    useEffect(() => {
        // If we have an initial chapter and study programs, find and select the corresponding program
        if (initialSelectedChapter && studyPrograms && !selectedStudyProgramId) {
            console.log("Looking for program with chapter:", initialSelectedChapter);
            const programWithChapter = studyPrograms.find(program => 
                program.chapters?.some(chapter => chapter.id === initialSelectedChapter.id)
            );
            console.log("Found program:", programWithChapter?.id);
            if (programWithChapter) {
                setSelectedStudyProgramId(programWithChapter.id);
            }
        }
    }, [initialSelectedChapter, studyPrograms]);

    const currentStudyProgram = studyPrograms?.find(
        (s) => s.id === selectedStudyProgramId
    );

    return (
        <>
            <StudyProgramsFilterList
                studentIds={hasRole(props.user, "student") ? null : studentIds}
                setSelectedStudyProgramId={setSelectedStudyProgramId}
                selectedStudyProgramId={selectedStudyProgramId}
                initialChapterId={initialSelectedChapter?.id}
            />
            {selectedStudyProgramId && (
                <View
                    style={{
                        flex: 1,
                        alignSelf: "center",
                        width: dimensions.width - 40,
                    }}
                >
                    <StudyProgramDisplayComponent
                        studyProgram={currentStudyProgram}
                        isLoading={false}
                        loadingMessage="Chargement du programme de révision..."
                        onPress={(item) => {
                            if (item?.chapter) {
                                onSelectChapter(item.chapter);
                            }
                        }}
                        highlightedChapterId={initialSelectedChapter?.id}
                    />
                </View>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    user: state.data.currentUser?.object,
    studyPrograms: state.data.studyPrograms?.studyPrograms,
});

export default connect(mapStateToProps)(StudyProgramChapterSelector); 